import React, { useEffect, useState } from 'react'

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from '@mui/material';
import {IconButton} from '@mui/material';
import { isEqual } from 'lodash';
import "../assessmentV2/AssessmentV2.css";
import {Close} from "@mui/icons-material";
import AssessmentQuestionV2 from "../assessmentV2/AssessmentQuestionV2";

const ModalSlider = (props) => {
	const {
		activeGroup: { name, questions },
		assessmentId,
		completedQuestions,
		firstGroup,
		handleClose,
		lastGroup,
		nextActiveGroup,
		onAnswer,
		previousActiveGroup,
		readOnly,
		remainingQuestions,
		reportType,
		submitted,
		user,
		validations,
		shouldShow
	} = props;

	const isIpathEs = reportType === 'IPATH_ES';

	const [slideIndex, setSlideIndex] = useState(0);
	const [previousGroupSlide, setPreviousGroupSlide] = useState(0);

	const visibleQuestions = questions.filter((question) => !shouldShow || shouldShow(question));
	const currentQuestion = visibleQuestions[slideIndex];
	const atEndOfVisibleQuestions = visibleQuestions.length === 0 || isEqual(slideIndex + 1, visibleQuestions.length);

	useEffect(() => {
		if (slideIndex >= visibleQuestions.length) {
			setSlideIndex(Math.max(visibleQuestions.length - 1, 0));
		}
	}, [visibleQuestions.length, slideIndex]);

	const previousSlideHandler = () => {
		if (slideIndex > 0) setSlideIndex(slideIndex - 1)
	};

	const nextSlideHandler = () => {
		if (slideIndex < visibleQuestions.length - 1) setSlideIndex(slideIndex + 1)
	};

	const previousGroupHandler = () => {
		previousActiveGroup();
		setSlideIndex(previousGroupSlide);
	};

	const nextGroupHandler = () => {
		nextActiveGroup();
		setPreviousGroupSlide(slideIndex);
		setSlideIndex(0);
	};

	const CustomDialogTitle = (props) => {
		const { children, onClose, ...other } = props;
		return (
			<DialogTitle {...other}>
				{children}
				{onClose ? (
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<Close />
					</IconButton>
				) : null}
			</DialogTitle>
		);
	};

	return (
		<Dialog open={true} fullScreen onClose={handleClose}>
			<CustomDialogTitle onClose={handleClose}>
				{name} {visibleQuestions.length > 0 ? slideIndex + 1 : 0}/{visibleQuestions.length}
			</CustomDialogTitle>
			<DialogContent>
				{currentQuestion ? (
					<AssessmentQuestionV2 key={currentQuestion.id}
						index={slideIndex}
						question={currentQuestion}
						assessmentId={assessmentId}
						readOnly={readOnly}
						submitted={submitted}
						onAnswer={onAnswer}
						valid={!submitted || (submitted && validations.get(currentQuestion.id))}
						reportType={currentQuestion?.template?.reportType}
						user={user} />
				) : (
					<div>{isIpathEs ? 'No hay preguntas aplicables.' : 'No applicable questions.'}</div>
				)}
			</DialogContent>
			<DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
				<div>
					<div>{isIpathEs ? 'Preguntas Completadas' : 'Questions Completed'}: {completedQuestions}</div>
					<div>{isIpathEs ? 'Preguntas restantes' : 'Questions Remaining'}: {remainingQuestions}</div>
				</div>
				<div style={{ minWidth: '325px', display: 'flex', justifyContent: 'space-between' }}>
					<Button
						variant="outlined"
						style={{ width: '160px' }}
						onClick={isEqual(slideIndex, 0) ? previousGroupHandler : previousSlideHandler}
						disabled={firstGroup && isEqual(slideIndex, 0)}>
						{isEqual(slideIndex, 0) ? (isIpathEs ? 'Grupo anterior de preguntas' : 'Previous Group') : (isIpathEs ? 'Anterior' : 'Previous')}
					</Button>
					{atEndOfVisibleQuestions
						? (
							<Button
								color="primary"
								variant="outlined"
								onClick={lastGroup ? handleClose : nextGroupHandler}
								style={{ color: 'green', borderColor: 'green', width: '160px' }}>
								{lastGroup ? (isIpathEs ? 'Finalizar' : 'Finish') : (isIpathEs ? 'Grupo siguiente de preguntas' : 'Next Group')}
							</Button>
						)
						: (
							<Button
								color="primary"
								variant="outlined"
								onClick={nextSlideHandler}
								style={{ color: 'green', borderColor: 'green', width: '160px' }}>
								{isIpathEs ? 'Siguiente' : 'Next'}
							</Button>
						)}
				</div>
			</DialogActions>
		</Dialog>
	)
}

export default ModalSlider
